export default __webpack_public_path__ + "static/media/medicare-logo-green.9e8316a5.svg";